<template>
  <w-sliding-popup type="setting" ref="slidingPopup" title="모델링 결과" width="600px" @close="close()">
    <div slot="content">
      <el-row class="title-bar" type="flex" justify="end">
        <w-header-search-button @click="showSearchTool = !showSearchTool"></w-header-search-button>
      </el-row>
      <el-table-wrapper ref="resultTable" max-height="500" :column-default="columnDefault" :data="tableData" :columns="tableColumns" remote pagination :total="total"
      :show-search-tool="showSearchTool" :show-custom-header="true" @condition-change="loadData">
      </el-table-wrapper>
    </div>
    <div slot="footer">
      <el-button size="large" type="solid" @click="close">닫기</el-button>
    </div>
  </w-sliding-popup>
</template>

<script>
import { isNil } from 'lodash';
import { getDateToString } from '@/utils/date';
import { EMPTY_TEXT } from '@/utils/string';
import { columnDefault } from '@/constants/table';
import deviceRegistrationAmsAPI from '@/api/settings/common/device-registration-ams';

const dateFormatter = (row, column, value) => (isNil(value) ? EMPTY_TEXT : getDateToString(value));
const statusFormatter = (row, column, value) => {
  let statusLabel = EMPTY_TEXT;
  switch (value) {
    case 'R': statusLabel = '대기'; break;
    case 'I': statusLabel = '진행중'; break;
    case 'C': statusLabel = '완료'; break;
    default: break;
  }
  return statusLabel;
};
const resultFormatter = (row, column, value) => {
  let resultLabel = EMPTY_TEXT;
  if (row.statusFlag === 'R') return resultLabel;
  switch (value) {
    case '1': resultLabel = '성공'; break;
    case '0': resultLabel = '실패'; break;
    default: break;
  }
  return resultLabel;
};

export default {
  name: 'WIpScanResultPopup',
  props: {
    selectedRange: Object,
  },
  data() {
    return {
      columnDefault,
      total: 0,
      showSearchTool: false,
      tableData: [],
      tableColumns: [
        { prop: 'targetIpaddress', label: 'IP', width: 200, searchable: true, remoteProp: 'target_ipaddress', sortable: true },
        { prop: 'statusFlag', label: '상태', formatter: statusFormatter },
        { prop: 'checkDatetime', label: '확인 시각', width: 150, searchable: true, remoteProp: 'check_datetime', sortable: true, searchType: 'date', formatter: dateFormatter },
        { prop: 'flag', label: '결과', formatter: resultFormatter },
      ],
    };
  },
  methods: {
    open() {
      this.$refs.slidingPopup.visible = true;
      this.$nextTick(() => {
        this.loadData();
      });
    },
    close() {
      this.showSearchTool = false;
      this.$refs.resultTable.clearFilter();
      this.$refs.slidingPopup.visible = false;
    },
    loadData() {
      const tableParams = this.$refs.resultTable.getParameter();
      deviceRegistrationAmsAPI.getAmsModelingResultList({ rangeId: this.selectedRange.id, ...tableParams }).then((response) => {
        if (response.data.success) {
          this.tableData = response.data.data;
          this.total = response.data.total;
        }
      });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/basic/DeviceRegistration/Server/popup/IpScanResultPopup.vue